// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contListIconsAgencys{
    width: 100%;
    height: 60%;
    border: 2px solid grey;
    border-bottom: 2px solid #003757;
    border-right: 2px solid #003757;
    display: flex;
    justify-content: start;
    align-items: center;
    overflow-x: auto;
    display: flex;
    overflow-x: auto; /* Permite el scroll horizontal */
    white-space: nowrap; /* Evita que los elementos se rompan a la siguiente línea */
    scrollbar-width: thin; /* Opcional: hace que el scrollbar sea más delgado (Firefox) */
    -webkit-overflow-scrolling: touch; /* Para scroll suave en dispositivos táctiles */

}
.fieldIconsAgencys{
    width: 60px;
    height: 96%;
    border: 1px solid gray;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 auto; /* Los elementos dentro del contenedor no se encogerán ni se expandirán */
    /* margin-right: 10px;  */
}
.fieldIconsAgencys:hover{
    background-color: #015f96a1;
    cursor: pointer;
}
.compactIconAgency:hover {
    width: 85%;
   height: 85%;
}
.compactIconAgency{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
   background-color: rgb(190, 188, 188);
   width: 80%;
   height: 80%;
}
.iconAgencySelected{
    background-color:#003757
}


input[type="color"] {
    cursor: pointer;
    width: 50px;
    height: 50px;
    border: none;
    background: none;
    outline: none;
    appearance: none;
}

input[type="color"]::-webkit-color-swatch-wrapper {
    padding: 0;
}

input[type="color"]::-webkit-color-swatch {
    border: none;
}

input[type="color"]::-moz-color-swatch {
    border: none;
}`, "",{"version":3,"sources":["webpack://./src/components/config-components/Excepciones/styles/createAgency.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,gCAAgC;IAChC,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,gBAAgB,EAAE,iCAAiC;IACnD,mBAAmB,EAAE,2DAA2D;IAChF,qBAAqB,EAAE,8DAA8D;IACrF,iCAAiC,EAAE,+CAA+C;;AAEtF;AACA;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc,EAAE,yEAAyE;IACzF,yBAAyB;AAC7B;AACA;IACI,2BAA2B;IAC3B,eAAe;AACnB;AACA;IACI,UAAU;GACX,WAAW;AACd;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;GACpB,oCAAoC;GACpC,UAAU;GACV,WAAW;AACd;AACA;IACI;AACJ;;;AAGA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,aAAa;IAEb,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".contListIconsAgencys{\r\n    width: 100%;\r\n    height: 60%;\r\n    border: 2px solid grey;\r\n    border-bottom: 2px solid #003757;\r\n    border-right: 2px solid #003757;\r\n    display: flex;\r\n    justify-content: start;\r\n    align-items: center;\r\n    overflow-x: auto;\r\n    display: flex;\r\n    overflow-x: auto; /* Permite el scroll horizontal */\r\n    white-space: nowrap; /* Evita que los elementos se rompan a la siguiente línea */\r\n    scrollbar-width: thin; /* Opcional: hace que el scrollbar sea más delgado (Firefox) */\r\n    -webkit-overflow-scrolling: touch; /* Para scroll suave en dispositivos táctiles */\r\n\r\n}\r\n.fieldIconsAgencys{\r\n    width: 60px;\r\n    height: 96%;\r\n    border: 1px solid gray;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex: 0 0 auto; /* Los elementos dentro del contenedor no se encogerán ni se expandirán */\r\n    /* margin-right: 10px;  */\r\n}\r\n.fieldIconsAgencys:hover{\r\n    background-color: #015f96a1;\r\n    cursor: pointer;\r\n}\r\n.compactIconAgency:hover {\r\n    width: 85%;\r\n   height: 85%;\r\n}\r\n.compactIconAgency{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n   background-color: rgb(190, 188, 188);\r\n   width: 80%;\r\n   height: 80%;\r\n}\r\n.iconAgencySelected{\r\n    background-color:#003757\r\n}\r\n\r\n\r\ninput[type=\"color\"] {\r\n    cursor: pointer;\r\n    width: 50px;\r\n    height: 50px;\r\n    border: none;\r\n    background: none;\r\n    outline: none;\r\n    -webkit-appearance: none;\r\n    appearance: none;\r\n}\r\n\r\ninput[type=\"color\"]::-webkit-color-swatch-wrapper {\r\n    padding: 0;\r\n}\r\n\r\ninput[type=\"color\"]::-webkit-color-swatch {\r\n    border: none;\r\n}\r\n\r\ninput[type=\"color\"]::-moz-color-swatch {\r\n    border: none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
